
import { Component, Vue } from 'vue-property-decorator';

import { namespace } from "vuex-class";
import "@/store/modules/information";
const informationState = namespace("Information");

import "@/store/modules/forms/form2";
const form2State = namespace("Form2");

import { form2DataInfoType } from '@/types/Information/Form2';
import { partiesDataJsonDataType } from '@/types/Information/json';
import { partiesContact } from '@/types/Information';

@Component
export default class Form2StyleOfProceeding extends Vue {

    @informationState.State
    public partiesJson: partiesDataJsonDataType;

    @informationState.State
    public fileNumber: string;

    @form2State.State
    public form2Info: form2DataInfoType;

    @form2State.Action
    public UpdateForm2Info!: (newForm2Info: form2DataInfoType) => void  
    
    @form2State.State
    public currentCaseId: string;

    @form2State.Action
    public UpdateCurrentCaseId!: (newCurrentCaseId: string) => void
    
    dataReady = false;
    applicantNames: string[] = [];
    respondentNames: string[] = [];
    partyNames: string[] = [];
    updated=0;
    showNoneBcAlert=false

    state = {
        firstAppellant: null,
        firstRespondent: null,
        filingParties:null,
        authorizedName: null,
        phoneNumbers: null,       
        addresses: null,
        email:null,
        nonBcAddress: null 
    }

    mounted() {
        this.dataReady = false;
        this.extractInfo();                
    }

    async getForm2Data() {
        
        this.$http.get('/case/'+this.currentCaseId+'/')
        .then((response) => {
            if(response?.data?.data){ 
                const form2Data = response.data.data                
                this.UpdateForm2Info(form2Data); 
                this.extractPartiesData();
                this.clearStates(); 
            }                
        },(err) => {
            console.log(err)        
        });      
    }

    public clearStates(){
        this.state = {
            firstAppellant: null,
            firstRespondent: null,
            filingParties:null,
            authorizedName: null,
            phoneNumbers: null,       
            addresses: null,
            email: null,
            nonBcAddress: null
        }
        this.dataReady = true; 
    }

    async extractInfo(){

        if(this.currentCaseId){
            await this.getForm2Data();
        } else {            
             
            const form2Data = {} as form2DataInfoType;
            form2Data.appellants = this.partiesJson.appellants;
            form2Data.respondents = this.partiesJson.respondents;
            form2Data.formSevenNumber = this.fileNumber;            
            form2Data.version = this.$store.state.Application.version;
            form2Data.filingParties = [];
            form2Data.addresses = [];
            form2Data.emailAdresses = [];
            form2Data.phoneNumbers = [];
            this.UpdateForm2Info(form2Data);           
            this.saveForm(true);
            
        } 
    }

    public extractPartiesData(){

        this.applicantNames = [];
        this.respondentNames = [];
        this.partyNames = [];               

        for (const applicant of this.form2Info.appellants){
            this.applicantNames.push(applicant.name);
            this.partyNames.push(applicant.name);
        }

        for (const respondent of this.form2Info.respondents){
            this.respondentNames.push(respondent.name);
            this.partyNames.push(respondent.name);            
        }        
        this.dataReady = true;
    }  

    public updateAddressFields(){

        const formData = this.form2Info;
        const addressData = formData.addresses? formData.addresses :[];
        const addresses: partiesContact[] = []; 
        const emailData = formData.emailAdresses? formData.emailAdresses :[];
        const emails: partiesContact[] = []; 
        const phoneData = formData.phoneNumbers? formData.phoneNumbers :[];
        const phoneNumbers: partiesContact[] = []; 

        for (const partyName of this.form2Info.filingParties){
           
            const matchingAddressRecords = addressData.filter(address => address.name == partyName);

            if (matchingAddressRecords.length == 0){
                addresses.push({name: partyName, contactInfo: ''});
            } else {                
                const index = addressData.findIndex(address => address.name == matchingAddressRecords[0].name);               
                addresses.push(addressData[index]);
            }

            const matchingPhoneRecords = phoneData.filter(phone => phone.name == partyName); 
            
            if (matchingPhoneRecords.length == 0){
                phoneNumbers.push({name: partyName, contactInfo: ''});
            } else {                
                const index = phoneData.findIndex(phone => phone.name == matchingPhoneRecords[0].name);               
                phoneNumbers.push(phoneData[index]);
            }

            const matchingEmailRecords = emailData.filter(email => email.name == partyName); 
            
            if (matchingEmailRecords.length == 0){
                emails.push({name: partyName, contactInfo: ''});
            } else {                
                const index = emailData.findIndex(email => email.name == matchingEmailRecords[0].name);               
                emails.push(emailData[index]);
            }
        }

        formData.addresses = addresses;
        formData.emailAdresses = emails;
        formData.phoneNumbers = phoneNumbers;
        this.UpdateForm2Info(formData)
        this.recheckStates();
        this.updated ++;               
    }

    public recheckStates(){
        for(const field of Object.keys(this.state)){
            if(this.state[field]==false){
                this.checkStates()
                return 
            }
        }
    }

    public checkStates(){ 
        this.state.firstAppellant = !this.form2Info.firstAppellant? false : null;
        this.state.firstRespondent = !this.form2Info.firstRespondent? false : null;
        this.state.filingParties = (this.form2Info.filingParties.length == 0)? false : null; 
        this.state.phoneNumbers = !(this.form2Info.phoneNumbers && this.verifyPhoneNumbers()
                                    && this.form2Info.phoneNumbers.length == this.form2Info.filingParties.length)? false : null;
        
        
        const verifiedAddresses = this.verifyAddresses()
        this.state.addresses = verifiedAddresses.valid;
        this.state.nonBcAddress = verifiedAddresses.nonBC;

        this.state.email = this.verifyEmails()? null: false;

        this.state.authorizedName = !this.form2Info.authorizedName? false : null; 
        
        for(const field of Object.keys(this.state)){
            if(this.state[field]==false){
                Vue.filter('findInvalidFields')()
                return false
            }
        }
        return true;            
    } 
    
    public verifyPhoneNumbers(){
        for(const phoneNumber of this.form2Info.phoneNumbers){            
            if(!Vue.filter('verifyPhone')(phoneNumber.contactInfo))            
                return false;
        }
        return true;
    }

    public verifyEmails(){
        for(const email of this.form2Info.emailAdresses){
            if(email.contactInfo && !Vue.filter('verifyEmail')(email.contactInfo))
                return false
        }
        return true
    }

    public verifyAddresses(){
        let nonBC = null
        for(const index in this.form2Info.addresses){ 
            const address = this.form2Info.addresses[index]
            const verifiedAddress = Vue.filter('verifyAddress')(address.contactInfo)
            
            if(verifiedAddress=='EMPTY' && (!this.form2Info.emailAdresses[index].contactInfo || !Vue.filter('verifyEmail')(this.form2Info.emailAdresses[index].contactInfo)))                  
                return {valid:false, nonBC:null};
            if(verifiedAddress=='ERR')
                return {valid:false, nonBC:null};
            if(verifiedAddress=='NONE_BC') nonBC = true
        }
        return {valid:null, nonBC:nonBC};
    }

    public extractAddresses(){
        const addresses = [];
        for(const contactAddress of this.form2Info.addresses){            
            if(contactAddress.contactInfo.trim().length != 0){
                addresses.push(contactAddress.name + ': ' + contactAddress.contactInfo.trim());
            }  
        }
        return addresses.join('<br>');        
    }

    public extractPhoneNumbers(){
        const phoneNumbers = [];
        for(const phone of this.form2Info.phoneNumbers){            
            if(phone.contactInfo.trim().length != 0){
                phoneNumbers.push(phone.name + ': ' + phone.contactInfo.trim());
            }  
        }
        return phoneNumbers.join('<br>');        
    }

    public extractEmails(){
        const emails = [];
        for(const email of this.form2Info.emailAdresses){            
            if(email.contactInfo.trim().length != 0){
                emails.push(email.name + ': ' + email.contactInfo.trim());
            }  
        }
        return emails.join('<br>');        
    }

    public saveForm(draft: boolean) { 
        
        const url = this.currentCaseId? ('/case/'+this.currentCaseId+'/') : '/case/';
        const method = this.currentCaseId? "put" : "post";
        const form2Data = this.form2Info;
        form2Data.contactAddress = this.extractAddresses();
        form2Data.emails = this.extractEmails();
        form2Data.phones = this.extractPhoneNumbers();
        this.UpdateForm2Info(form2Data);
        const body = {
            type: "form-2",
            status:"Draft",
            description:"form2",
            data: this.form2Info
        }  

        const options = {
            method: method,
            url: url,
            data: body
        }       
            
        if (this.currentCaseId && !draft && !this.checkStates()){               
            return                
        }             
        
        this.saveInfo(options, draft);              
       
    }

    public saveInfo(options, draft){

        this.$http(options)
            .then(response => {
                if(response.data){
                    if(options.method == "post"){
                        this.UpdateCurrentCaseId(response.data.case_id);
                        this.extractPartiesData();                       
                    }
                    this.clearStates();                    
                    if(!draft) this.navigateToPreviewPage();                           
                }
            }, err => {
                const errMsg = err.response.data.error;                
            })
    }   

    public navigateToPreviewPage() {          
        if (this.checkStates()){
            if(this.state.nonBcAddress)
               this.showNoneBcAlert=true
            else
                this.$router.push({name: "preview-form2"});
        }        
    }

    public confirmNavigateToPreviewPage(){
        this.showNoneBcAlert=false
        this.$router.push({name: "preview-form2"});
    }

}
